import React from 'react';
import { BarChart, LineChart, DollarSign, TrendingUp, ShoppingBag } from 'lucide-react';

export default function Analytics() {
  const revenueData = [
    { month: 'Jan', amount: 1200000 },
    { month: 'Feb', amount: 1500000 },
    { month: 'Mar', amount: 1800000 },
    { month: 'Apr', amount: 2100000 },
  ];

  const salesData = [
    { month: 'Jan', count: 120 },
    { month: 'Feb', count: 150 },
    { month: 'Mar', count: 180 },
    { month: 'Apr', count: 210 },
  ];

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-6">Analytics Overview</h2>
      
      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        <div className="bg-white p-6 rounded-xl shadow-sm">
          <div className="flex items-center gap-4">
            <div className="bg-green-100 p-3 rounded-lg">
              <DollarSign className="h-6 w-6 text-green-600" />
            </div>
            <div>
              <p className="text-sm text-gray-600">Monthly Revenue</p>
              <p className="text-2xl font-bold">₦2.1M</p>
              <p className="text-sm text-green-600">+15% from last month</p>
            </div>
          </div>
        </div>

        <div className="bg-white p-6 rounded-xl shadow-sm">
          <div className="flex items-center gap-4">
            <div className="bg-blue-100 p-3 rounded-lg">
              <ShoppingBag className="h-6 w-6 text-blue-600" />
            </div>
            <div>
              <p className="text-sm text-gray-600">Monthly Sales</p>
              <p className="text-2xl font-bold">210</p>
              <p className="text-sm text-blue-600">+12% from last month</p>
            </div>
          </div>
        </div>

        <div className="bg-white p-6 rounded-xl shadow-sm">
          <div className="flex items-center gap-4">
            <div className="bg-purple-100 p-3 rounded-lg">
              <TrendingUp className="h-6 w-6 text-purple-600" />
            </div>
            <div>
              <p className="text-sm text-gray-600">Conversion Rate</p>
              <p className="text-2xl font-bold">3.2%</p>
              <p className="text-sm text-purple-600">+0.5% from last month</p>
            </div>
          </div>
        </div>
      </div>

      {/* Charts */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white p-6 rounded-xl shadow-sm">
          <h3 className="text-lg font-semibold mb-4">Revenue Trend</h3>
          <div className="h-64 flex items-end justify-between gap-2">
            {revenueData.map((data, index) => (
              <div key={index} className="flex-1">
                <div 
                  className="bg-purple-600 hover:bg-purple-700 transition-colors rounded-t"
                  style={{ height: `${(data.amount / 2100000) * 100}%` }}
                ></div>
                <p className="text-xs text-center mt-2">{data.month}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-white p-6 rounded-xl shadow-sm">
          <h3 className="text-lg font-semibold mb-4">Sales Trend</h3>
          <div className="h-64 flex items-end justify-between gap-2">
            {salesData.map((data, index) => (
              <div key={index} className="flex-1">
                <div 
                  className="bg-blue-600 hover:bg-blue-700 transition-colors rounded-t"
                  style={{ height: `${(data.count / 210) * 100}%` }}
                ></div>
                <p className="text-xs text-center mt-2">{data.month}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}